const jarvisPrimeExistingHoldingConstants = {
  EXISTING_HOLDING_PRIME_LIST_API: "/prime/prime",
  EXISTING_HOLDING_STOCK_LIST_API: "/prime/prime",
  EXISTING_HOLDING_UPDATE_PRIMENAME_API: "/prime/prime",
  EXISTING_HOLDING_ADD_STOCK_TO_PRIME_API: "/prime/prime",
  EXISTING_HOLDING_REMOVE_STOCK_TO_PRIME_API: "/prime/prime",
  EXISTING_HOLDING_REMOVE_PRIME_API: "/prime/prime",
  EXISTING_HOLDING_EDIT_STOCK_API: "/prime/prime",

  JARVIS_PRIME_RESET_EXISTING_HOLDING_DATA:
    "JARVIS_PRIME_RESET_EXISTING_HOLDING_DATA",

  EXISTING_HOLDING_RESPONSE: "EXISTING_HOLDING_RESPONSE",
  EXISTING_HOLDING_REQUEST: "EXISTING_HOLDING_REQUEST",
  EXISTING_HOLDING_SAGA: "EXISTING_HOLDING_SAGA",
  EXISTING_HOLDING_API: "v1/prime/allocations",

  STOCK_LIST_RESPONSE: "STOCK_LIST_RESPONSE",
  STOCK_LIST_REQUEST: "STOCK_LIST_REQUEST",
  STOCK_LIST_SAGA: "STOCK_LIST_SAGA",
  STOCK_LIST_API: "v1/prime/allocations",
};

export { jarvisPrimeExistingHoldingConstants };
